import React from "react"
import Navbar from "../bootstrap/navbar"
import NavbarToggle from "../bootstrap/navbar_toggle"
import NavbarCollapse from "../bootstrap/navbar_collapse"
import Nav from "../bootstrap/nav"
import NavItem from "../bootstrap/nav_item"
import Container from "../bootstrap/container"
import Icon from "../../assets/svg/dmae-icon.inline.svg"
import {
  topNavbar,
  dmaeIcon,
  navLink,

} from "./navigation.module.scss"
import { Link } from "gatsby"
 
const Layout = ({ academicsMenu, newsMenu, studentMenu }) => {
  let AcademicsDefaultClass = ""
  if (academicsMenu) {
    AcademicsDefaultClass = "active"
  }

  let StudentLifeActive = ""
  if (studentMenu) {
    StudentLifeActive = "active"
  }

  let NewsEventsActive = ""
  if (newsMenu) {
    NewsEventsActive = "active"
  }

  return (
    <Navbar
      id={topNavbar}
      bg="primary"
      variant="dark"
      expand="md"
      className="py-2"
    >
      <Container>
        <div className="py-0">
          <Link to="/">
            <Icon className={dmaeIcon} viewBox="0 0 32 32" />
          </Link>
        </div>
        <NavbarToggle ariacontrols="basic-navbar-nav" />
        <NavbarCollapse id="basic-navbar-nav" className="justify-content-end">
          <Nav as="ul">
            <NavItem as="li" bsPrefix={`nav-item`}>
              <Link
                to="/"
                className={`${navLink} nav-link`}
                activeClassName="active"
              >
                Home
              </Link>
            </NavItem>
            <NavItem as="li" bsPrefix={` nav-item`}>
              <Link
                to="/academics/"
                className={`${navLink} ${AcademicsDefaultClass} nav-link`}
                activeClassName="active"
              >
                Academics
              </Link>
            </NavItem>
            <NavItem as="li" bsPrefix={` nav-item`}>
              <Link
                to="/admissions/"
                className={`${navLink} nav-link`}
                activeClassName="active"
              >
                Admissions
              </Link>
            </NavItem>
            <NavItem as="li" bsPrefix={` nav-item`}>
              <Link
                to="/news-and-events/"
                className={`${navLink} ${NewsEventsActive} nav-link`}
                activeClassName="active"
              >
                News and Events
              </Link>
            </NavItem>
            <NavItem as="li" bsPrefix={` nav-item`}>
              <Link
                to="/students/"
                className={`${navLink} ${StudentLifeActive} nav-link`}
                activeClassName="active"
              >
                Student Life
              </Link>
            </NavItem>
            <NavItem as="li" bsPrefix={` nav-item`}>
              <Link
                to="/contact/"
                className={`${navLink} nav-link`}
                activeClassName="active"
              >
                Contact
              </Link>
            </NavItem>
            <NavItem as="li" bsPrefix={` nav-item`}>
              <Link
                to="/about/"
                className={`${navLink} nav-link`}
                activeClassName="active"
              >
                About
              </Link>
            </NavItem>
            <NavItem as="li" bsPrefix={` nav-item`}>
              <Link
                to="/faq/"
                className={`${navLink} nav-link`}
                activeClassName="active"
              >
                FAQ
              </Link>
            </NavItem>
          </Nav>
        </NavbarCollapse>
      </Container>
    </Navbar>
  )
}
export default Layout
